module.exports = "build/assets/RingsideRegular-Med.c7507053.ttf";